import React, { useState, useEffect } from 'react';
import './App.css'; // We'll create this CSS file
// Import components
import MainMenu from './components/MainMenu';
import BuySellUSDTForm from './components/BuySellUSDTForm';
import AlipayWechatForm from './components/AlipayWechatForm';
import RescheduleForm from './components/RescheduleForm';
import MyRequests from './components/MyRequests';
import AboutUs from './components/AboutUs';
import ReferralProgram from './components/ReferralProgram';
import Rules from './components/Rules'; // Импортируем компонент Правил

const API_ENDPOINT = 'https://pay2buy.ru/api'; // <--- IMPORTANT: Replace with your actual backend URL

function App() {
    const webApp = window.Telegram.WebApp
    const [currentView, _setCurrentView] = useState('mainMenu'); // 'mainMenu', 'buySellUSDT', 'alipayWechat', 'reschedule', 'rules', etc.
    const [previousView, setPreviousView] = useState('mainMenu'); // Для возврата со страницы правил
    const [myRequests, setMyRequests] = useState([]); // New state for user requests
    const [loadingRequests, setLoadingRequests] = useState(false); // New state for loading indicator
    const [requestsError, setRequestsError] = useState(null); // New state for request errors
    const [isAppLoading, setIsAppLoading] = useState(true); // State for initial app load



    // Initialize WebApp on component mount
    useEffect(() => {
        if (webApp) {
            webApp.ready();
            webApp.expand(); // Expand Mini App to full screen
            setIsAppLoading(false); // App is ready to be shown
        }
        // Если webApp не определен сразу (например, скрипт Telegram еще не загрузился), 
        // можно добавить здесь `else { setIsAppLoading(false); }` или обработать это состояние иначе,
        // но обычно webApp должен быть доступен к моменту выполнения этого useEffect.
    }, [webApp]);

    // Обновленная функция для установки текущего вида и запоминания предыдущего
    const setCurrentView = (view, prev = null) => {
        if (view === 'previous') {
            _setCurrentView(previousView);
        } else {
            setPreviousView(prev || currentView); // Если prev не указан, используем текущий currentView
            _setCurrentView(view);
        }
    };
    const handleSubmit = async (e, formType) => {
        e.preventDefault();
        if (!webApp) {
            alert("Telegram Web App is not initialized.");
            return;
        }

        const formData = new FormData(e.target);
        const data = {
            type: formType,
            telegram_user_id: webApp.initDataUnsafe?.user?.id || 'N/A', // Get user ID from Telegram
            ...Object.fromEntries(formData.entries()),
        };

        console.log('Sending data:', data);

        try {
            const response = await fetch(`${API_ENDPOINT}/submit-request`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                alert('Заявка успешно отправлена!');
                webApp.close(); // Close Mini App after successful submission
            } else {
                const errorText = await response.text();
                alert(`Ошибка при отправке заявки: ${errorText}`);
            }
        } catch (error) {
            console.error('Network or server error:', error);
            alert('Произошла ошибка при отправке заявки. Пожалуйста, попробуйте еще раз.');
        }
    };

    const fetchMyRequests = async () => {
        if (!webApp || !webApp.initDataUnsafe?.user?.id) {
            alert("Не удалось получить ваш Telegram ID.");
            return;
        }

        setLoadingRequests(true);
        setRequestsError(null);
        setCurrentView('myRequests', 'mainMenu'); // Switch to requests view, remember to return to mainMenu

        try {
            const userId = webApp.initDataUnsafe.user.id;
            const response = await fetch(`${API_ENDPOINT}/requests/${userId}`); // New API endpoint

            if (response.ok) {
                const data = await response.json();
                setMyRequests(data);
            } else {
                const errorText = await response.text();
                setRequestsError(`Ошибка при загрузке заявок: ${errorText}`);
                setMyRequests([]);
            }
        } catch (error) {
            console.error('Error fetching requests:', error);
            setRequestsError('Произошла ошибка сети или сервера при загрузке заявок.');
            setMyRequests([]);
        } finally {
            setLoadingRequests(false);
        }
    };
    // Handler for "Support" button - opens Telegram contact
    const handleSupportClick = () => {
        // Replace 'your_support_username' with the actual Telegram username of your support
        window.Telegram.WebApp.openTelegramLink('https://t.me/slowvao');
    };

    if (isAppLoading) {
        return (
            <div className="app-loader-container">
                <div className="app-loader-text">Загрузка приложения...</div>
            </div>
        );
    }

    return (
        <div className="App">
            <div className="container">
                <img src={require('./logotype.svg').default} alt="PAY2BUY" className="img-logotype" />
                {/* <h1>PAY2BUY</h1> */}
                {currentView === 'mainMenu' && (
                    <MainMenu
                        setCurrentView={setCurrentView}
                        fetchMyRequests={fetchMyRequests}
                        handleSupportClick={handleSupportClick}
                    />
                )}
                {currentView === 'buySellUSDT' && (
                    <BuySellUSDTForm
                        handleSubmit={handleSubmit}
                        setCurrentView={setCurrentView}
                    />
                )}
                {currentView === 'alipayWechat' && (
                    <AlipayWechatForm
                        handleSubmit={handleSubmit}
                        setCurrentView={setCurrentView}
                    />
                )}
                {currentView === 'reschedule' && (
                    <RescheduleForm
                        handleSubmit={handleSubmit}
                        setCurrentView={setCurrentView}
                    />
                )}
                {currentView === 'myRequests' && (
                    <MyRequests
                        myRequests={myRequests}
                        loadingRequests={loadingRequests}
                        requestsError={requestsError}
                        setCurrentView={setCurrentView}
                    />
                )}
                {currentView === 'aboutUs' && <AboutUs setCurrentView={setCurrentView} />}
                {currentView === 'referralProgram' && <ReferralProgram setCurrentView={setCurrentView} />}
                {currentView === 'rules' && <Rules setCurrentView={setCurrentView} />}
            </div>
        </div>
    );
}

export default App;